import {
  Field,
  Model,
} from 'serialize-ts';

@Model()
export class ProductPromotion {
  @Field()
  endDate: Date;

  constructor() {
    this.endDate = new Date();
  }
}
